export enum CustomSpreadMessages {
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND',
  INVALID_CURRENCY_FORMAT = 'INVALID_CURRENCY_FORMAT',
  INVALID_SPREAD_VALUE = 'INVALID_SPREAD_VALUE',
  MISSING_REQUIRED_FIELDS = 'MISSING_REQUIRED_FIELDS',
  SAVED_SUCCESSFULLY = 'SAVED_SUCCESSFULLY',
  FEATURE_FLAG_UNAVAILABLE = 'FEATURE_FLAG_UNAVAILABLE',
}

export interface CustomSpread {
  currency: string;
  spread?: string;
}

export interface CompanyCustomSpread {
  company: string;
  isActive: boolean;
  customSpreads: CustomSpread[];
}

export interface CompanyCustomSpreadResponse {
  records: CompanyCustomSpread;
  statusCode?: number;
  errorMessages?: { message: string; property?: string }[] | [];
  success: boolean;
}

export interface CurrencyInfo {
  currencyCode: string;
  symbol: string;
}

export interface CurrenciesResponse {
  records: CurrencyInfo[];
}

export enum ModalStep {
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  CUSTOM_SPREAD = 'CUSTOM_SPREAD',
}

export const DEFAULT_SPREAD = 0.50;
export const MIN_SPREAD = 0;
export const MAX_SPREAD = 10;
